import React, { FC } from 'react';
import { HistorySnapshot } from './serialNumbers';
import moment from 'moment';
import 'moment/locale/it';
import {
    TimelineItem,
    TimelineDot,
    TimelineSeparator,
    TimelineConnector,
    TimelineContent,
    TimelineOppositeContent,
    Skeleton
} from '@material-ui/lab';
import { SerialNumberHistoryItemComponent } from './SerialNumberHistoryItemComponent';
import { Card, CardContent, Typography } from '@material-ui/core';
import { SerialNumberHistorySeparator } from './SerialNumberHistorySeparator';

export const SerialNumberHistoryItem: FC<{snapshot?: HistorySnapshot, index: number}> = ({snapshot, index}) => (
    !snapshot ? (
        <TimelineItem>
            <TimelineOppositeContent>
                <Skeleton variant="text" animation="wave" width="50%" />
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
            <Skeleton variant="text" animation="wave" width="50%" />
            </TimelineContent>
        </TimelineItem>
    ) : (
        <TimelineItem>
            <TimelineOppositeContent>
                <Typography style={{ marginTop: 8 }} color="textSecondary">
                    {moment(snapshot.date).format('lll')}
                </Typography>

                <Card elevation={0}>
                    <CardContent>
                        <Typography variant="body1">{snapshot.notes}</Typography>
                    </CardContent>
                </Card>
            </TimelineOppositeContent>
            <SerialNumberHistorySeparator components={snapshot.components} />
            <TimelineContent>
                <Typography style={{ marginTop: 8 }}>
                    {snapshot.author.name}
                </Typography>
                
                {snapshot.components?.map((component, key) => (
                    <SerialNumberHistoryItemComponent
                        key={key}
                        component={component}
                        justifyContent={(index % 2) == 1 ? "flex-end" : "flex-start"}
                    />
                ))}
            </TimelineContent>
        </TimelineItem>
    )
)